import { createAction, props } from '@ngrx/store';
import { SocketSubscription } from '@mode/shared/data-access-socket';
import { ReportCloneSuccessPayload } from './report-clone.models';
import { ReportResource } from '@mode/shared/data-access-webapp';

export const initReportClone = createAction(
  '[ReportClone Page] Init',
  props<{ ownerId: string; reportId: string; runId: string; reportWorkspace: string }>()
);

export const initReportCloneSuccess = createAction(
  '[ReportClone API] Init ReportClone Success',
  props<{ reportId: string; channelName: string }>()
);

export const initReportCloneFailure = createAction(
  '[ReportClone API] Init ReportClone Failure',
  props<{ reportId: string; error: any }>()
);

export const reportCloneSocketConnectionSuccess = createAction(
  '[ReportClone API] ReportClone Socket Connection Success',
  props<{ reportId: string; reportCloneSubscription: SocketSubscription<ReportCloneSuccessPayload> }>()
);

export const reportCloneSuccess = createAction(
  '[ReportClone API] ReportClone Success',
  props<{ reportId: string; clonedReportApiUrl: string; clonedReportLink: string }>()
);
export const reportClonePending = createAction('[ReportClone API] ReportClone Pending', props<{ reportId: string }>());
export const reportCloneFailed = createAction('[ReportClone API] ReportClone Failed', props<{ reportId: string }>());

export const reportCloneInProgress = createAction(
  '[ReportClone API] ReportClone In Progress',
  props<{ reportId: string; progressToastId: number }>()
);

export const clonedReportLoaded = createAction(
  '[ReportClone API] Cloned Report Loaded',
  props<{ clonedReport: ReportResource }>()
);
